import React, { ComponentProps, useEffect } from 'react'

import { EmbedValueProposition } from 'components/common/Embed/EmbedValueProposition/EmbedValueProposition'
import { announceFlowLoaded } from '../routing/flowLoadedGate'

type Props = {
  onSelect: ComponentProps<typeof EmbedValueProposition>['onSelect']
}

export const EmbedOverlayEntry: React.FC<Props> = ({ onSelect }) => {
  useEffect(() => {
    announceFlowLoaded('overlay')
  }, [])

  return <EmbedValueProposition onSelect={onSelect} />
}
